enum BarrelOnboardingType {
    Sample = "sample",
    Figma = "figma"
}

export default BarrelOnboardingType;
